import React from "react";
import './committees.css';
import HeaderComponent from "../header/header";
import NavbarComponent from "../header/top.navbar";
import FooterComponent from "../footer/footer";
import {FaEnvelope, FaPhone, FaUser,FaUserTie,FaIdCard } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const CommitteeComponent = () => {


    const committeeData = [
        {
          category: "Membership and Publicity",
          members: [
            "Dr Somsing Rathod",
            "Smt. Sushma BR"
          ]
        },
        {
          category: "Sponsorship",
          members: [
            "Shri. Gampala Viswam",
            "Shri. Saleem Javeed"
          ]
        },
        {
          category: "Administrative & Finance",
          members: [
            "Smt. Meera Das",
            "Shri. Anand Sai Verma"
          ]
        },
        {
          category: "Future Conferences, Workshop/Tutorials",
          members: [
            "Dr. Ashutosh Kedar"
          ]
        },
        {
          category: "Academics, Industry Interaction and Promotion",
          members: [
            "Dr. A Vengadarajan"
          ]
        }
      ];
 

  return (
    <>
      <Helmet>
        <title>COMMITTEE SMARTFORUM - Society for Microwaves, Antennas and Radar Technologies</title>
        <meta name="description" content="Join SMART, a technology-driven community shaping the future of innovation, research, and collaboration." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <HeaderComponent/> 
      <NavbarComponent/>
      <section id="fixed-sub-nav" className="gradient-background" style={{paddingBottom: '30px', paddingTop: '30px'}}>
      <div className="container commitee-wrap">
             <h3 className="text-center mb-4 committee-main-title ">SMART Committee Members</h3>
          
          <div className="committee-sections-wrapper">
            {committeeData.map((section, index) => (
              <div key={index} className="committee-section-card">
                <div className="section-header">
                  <h2 className="section-title">{section.category}</h2>
                  <div className="section-divider"></div>
                </div>
                <div className="members-list">
                  {section.members.map((member, idx) => (
                    <div key={idx} className="member-name">
                      <span className="name-bullet">•</span>
                      {member}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <FooterComponent/>
    </>
  );
};

export default CommitteeComponent;
